export default class GlobalSearchComponent {
  constructor(element) {
    this.el = element
	this.searchbutton = this.el.querySelector(".search-submit")
	this.searchtext = this.el.querySelector("#search")
    this.init()
  }

  init() {
    
	if(this.searchbutton) {
		
		this.searchbutton.addEventListener("click", event => {
			
			if(this.searchtext) {
				if(this.searchtext.value) {
					
					//get sc_lang query string if exists
					var lang = getParameterByName('sc_lang');
					var buildQuery = "";
					
					if(lang) {
						buildQuery = "?query=" + this.searchtext.value + "&amp;sc_lang=" + lang;
					} 
					else {
						
						buildQuery = "?query=" + this.searchtext.value;
					}
					
					window.location.href = "/soeg" + buildQuery;
				}
			}
				
		});
		
		//return press event
		this.searchtext.addEventListener("keyup",  event => {
			if (event.keyCode === 13) {
			// Cancel the default action, if needed
				event.preventDefault();
			// Trigger the button element with a click
				this.searchbutton.click();
			}	
		});
	}
	
  }
}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

